declare let window: any;

export function isBrowserSupported() {
  if (!window) {
    return false;
  }
  return true;
  // return 'showDirectoryPicker' in window;
}
